import { sliceText } from "helpers/FieldHelper";
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import SortHelper from "helpers/SortHelper";
import { toTime } from "helpers/DateHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import UICalendar from "components/UI/Calendar/Calendar";
import UIMultiCalendar from "components/UI/MultiCalendar/MultiCalendar";
import { canShow } from "helpers/CalendarHelper";
import { showConfirmMsgDlg } from 'helpers/AppHelper';

export const CARTREQUEST_CONTENT_ITEMS = [
    {
        name: "customer_data", children: [
            { name: "customer_address", htmlClasses: "cartrequest-bold" },
            { name: "delivery_address", intl: "cartrequest.delivery_address" },
            { name: "invoice_address", intl: "cartrequest.invoice_address" },
        ]
    },
    {
        name: "work_data", children: [
            {
                name: "work_info", intl: "cartrequest.work", isWork: true,
                htmlClasses: "cartrequest-bold", type: ConfigTypes.ITEMS_CARTLIST
            },
            {
                name: "delivery_info", children: [
                    { name: "shipping_kind", type: "info", intl: "cartrequest.shippingtype" }
                ]
            },
            {
                name: "rights_info", intl: "cartrequest.rightsinfo", children: [
                    { name: "rights_film", type: "info", intl: "cartrequest.info.rightsfilm" },
                    { name: "rights_linebreak", type: "breakline", noLine: true },
                    {
                        name: "rights_transfer", type: "info", intl: "cartrequest.info.rightstransfer",
                        htmlClasses: "cartrequest-rightsbox"
                    }
                ]
            },
        ]
    },
    {
        name: "item_data", children: [
            {
                name: "item_info", intl: "cartrequest.item", type: ConfigTypes.ITEMS_CARTLIST,
                isItem: true,
                data: [
                    { name: "iteminfo_linebreak", type: "breakline", noLine: true, cart_requestorder: 4 },
                    {
                        name: "screening_start", field: "onlyForCartscreeningStart", type: "text",
                        intl: "cartrequest.screeningstart", cart_requestorder: 5
                    },
                    {
                        name: "screening_end", field: "onlyForCartscreeningEnd", type: "text",
                        intl: "cartrequest.screeningend", cart_requestorder: 6
                    }
                ]
            },
            {
                name: "item_count", isItem: true, type: ConfigTypes.ITEMS_CARTLIST,
                data: [
                    {
                        name: "itemcount_total", type: "text", field: "onlyForCartscreeningCount",
                        intl: "cartrequest.screeningcount"
                    },
                    { name: "iteminfo_linebreak", type: "breakline", noLine: true },
                    {
                        name: "itemcount_dates", type: ConfigTypes.DATES, field: "onlyForCartscreeningDates",
                        intl: "cartrequest.screeningdate"
                    }
                ]
            },
            {
                name: "item_comments", isItem: true, type: ConfigTypes.ITEMS_CARTLIST, data: [
                    { name: "cart_remark", type: "info", intl: "cartrequest.info.remark" },
                    { name: "cart_comments", type: "info", intl: "cartrequest.info.comments" }
                ]
            },
        ]
    },
    {
        name: "bank_data", children: [
            { name: "bank_info", intl: "cartrequest.bankinfo", type: ConfigTypes.OWNER_INST, data: [] },
            {
                name: "fee_info",
                type: ConfigTypes.INVOICE,
                data: [
                    { name: "rental_fee", field: "rentalFee", intl: "cartrequest.rentalfee", type: "text" },
                    { name: "shipping_fee", field: "shippingFee", intl: "cartrequest.shippingfee", type: "text" },
                    { name: "key_fee", field: "keyFee", intl: "cartrequest.keyfee", type: "text" },
                    { name: "processing_fee", field: "processingFee", intl: "cartrequest.processingfee", type: "text" },
                    { name: "vat_fee", field: "vatFee", intl: "cartrequest.vatfee", type: "text" },
                    { name: "cart_total", field: "cartTotal", intl: "cartrequest.carttotal", type: "text", htmlClasses: "cartrequest-bold" },
                    { name: "iteminfo_linebreak", type: "breakline", noLine: true },
                    { name: "payment_info", type: "info", intl: "cartrequest.paymentinfo" }
                ]
            },
            {
                name: "termsofuse_info", htmlClasses: "cartrequest-btnbox", children: [
                    {
                        name: "termofuse_link", intl: "cartrequest.termsofuse", type: "link",
                        txtLinkUrl: "https://www.deutsche-kinemathek.de/de/sammlungen-archive/bibliothek/benutzungsordnung-datenschutz",
                    },
                    { name: ConfigTypes.ACCEPT_OFFER, intl: "cartrequest.accept_offer", type: "button" },
                    { name: ConfigTypes.DENY_OFFER, intl: "cartrequest.deny_offer", type: "button" }
                ]
            },
        ]
    }
];

export const randomNr = () => {
    return Math.round(Math.random() * 10000);
}

export const getCartCount = ({ cartObjects }) => {
    const { itemsWishList, worksWishList, itemsCartList } = cartObjects;
    let wCount = itemsWishList.length + worksWishList.length;
    let cCount = itemsCartList.length;

    return { wishlistCount: wCount, cartCount: cCount };
}

export const toggleListItem = ({ cartObjects, configName, item }) => {
    const list = cartObjects[`${configName}sWishList`];
    let newItems = [...list];
    let elIdx = newItems.findIndex(el => el.id == item.id);
    if (elIdx > -1) newItems.splice(elIdx, 1);
    else newItems.push(item);

    return newItems;
}

export const addToCart = ({ cartObjects, configName, item }) => {
    const list = cartObjects[`${configName}sCartList`];
    let newItems = [...list];
    let elIdx = newItems.findIndex(el => el.id == item.id);
    if (elIdx > -1) return false;
    else newItems.push(item);
    return newItems;
}

export const addWorkFieldsToItem = ({ work, item, addFields, viewMode }) => {
    if (work && item && addFields && addFields.length > 0) {
        addFields.forEach(el => {
            let newValue = null;
            if (el && el[`${viewMode}group`]) {
                newValue = "";
                if (work.metadata && work.metadata.fields && work.metadata.fields[el.field]) {
                    newValue = work.metadata.fields[el.field];
                }

                if (work.metadata && work.metadata.fields
                    && work.metadata.fields[el[`${viewMode}group`].with]) {
                    newValue += " " + work.metadata.fields[el[`${viewMode}group`].with];
                }
            } else {
                if (work.metadata && work.metadata.fields && work.metadata.fields[el.field]) {
                    newValue = work.metadata.fields[el.field];
                }
            }
            if (item.metadata && item.metadata.fields) {
                if (el[`${viewMode}datetype`]) {
                    newValue = sliceText(newValue, el[`${viewMode}datetype`]);
                }
                // item.metadata.fields[el.field] = newValue;
                item.metadata.fields[`${ConfigTypes.ONLY_CART}${el.field}`] = newValue;
                item[`${ConfigTypes.ONLY_CART}${el.field}`] = newValue;
            }
        })
    }
    return item;
}

export const getNewItems = ({ mediaObjects, cartObjects, configObjects }) => {
    const { currentClip, currentWork } = mediaObjects;
    let buff = { metadata: { fields: {} } };
    if (currentClip && currentClip.metadata && currentClip.metadata.fields) {
        buff.id = currentClip.id;
        buff.metadata.fields = { ...currentClip.metadata.fields };
    }
    const addFields = getMetaConfig({
        viewMode: ConfigTypes.CARTLIST_WORKTOITEM,
        props: { configObjects }, configName: ConfigTypes.WORK
    });
    let addItem = addWorkFieldsToItem({
        work: currentWork, addFields,
        // item: currentClip, 
        item: buff,
        viewMode: ConfigTypes.CARTLIST_WORKTOITEM
    });

    let newItems = addToCart({
        cartObjects: cartObjects,
        configName: ConfigTypes.ITEM,
        item: addItem
    });
    return newItems;
}

export const getFi = () => {
    return `${ConfigTypes.ONLY_CART}screening`;
};

export const getItemStyle = ({ item, el }) => {
    if (el && el.name && el.name.startsWith(`${ConfigTypes.ITEM}_`)) {
        let datesCount = item.metadata.fields[`${getFi()}Count`];
        datesCount = +datesCount + 2;
        let lines = ConfigTypes.DEFAULT_ITEM_LINES;
        if (datesCount > lines) lines = datesCount;
        let height = Number(lines) * ConfigTypes.DEFAULT_LINE_HEIGHT;
        if (el.name !== ConfigTypes.ITEM_INFO) {
            height += ConfigTypes.DEFAULT_LINE_HEIGHT;
        }
        return { height: `${height}px` };
    }
    return null;
}


export const getStartEndDate = ({ entry, item, start, end }) => {
    if (start) {
        if (!entry[start]) {
            if (item[start]) entry[start] = item[start];
        } else {
            if (item[start] && toTime(item[start]) < toTime(entry[start])) {
                entry[start] = item[start];
            }
        }
        return entry[start];
    }
    if (end) {
        if (!entry[end]) {
            if (item[end]) entry[end] = item[end];
        } else {
            if (item[end] && toTime(item[end]) > toTime(entry[end])) {
                entry[end] = item[end];
            }
        }
        return entry[end];
    }
    return null;
}

export const reduceDataByFi = ({ el, list, fiName, dataArr, mode }) => {
    let exitst, uniFi;
    let data = [];
    let start = `${ConfigTypes.ONLY_CART}screeningStart`;
    let end = `${ConfigTypes.ONLY_CART}screeningEnd`;
    if (el && el.data && el.data.length > 0) data = el.data;
    else if (dataArr && dataArr.length) data = dataArr;
    if (data && data.length > 0) {
        if (!mode) mode = ConfigTypes.CART_REQUEST;
        exitst = data.filter(entry => entry[`${mode}${fiName}`]);
        if (exitst) uniFi = `${ConfigTypes.ONLY_CART}${exitst[0].field}`;
    }
    return list.reduce((acc, item) => {
        let found = acc.find(entry => entry[uniFi] == item[uniFi]);
        let fi = `${ConfigTypes.ONLY_CART}itemsCount`;
        if (!found) {
            acc.push({ ...item, [fi]: 1, [start]: item[start], [end]: item[end] });
        } else {
            acc = acc.map(entry => {
                if (entry[uniFi] == item[uniFi]) {
                    entry[fi] = entry[fi] + 1;
                    //date start - end
                    entry[start] = getStartEndDate({ entry, item, start });
                    entry[end] = getStartEndDate({ entry, item, end });
                }
                return entry;
            })
        }
        return acc;
    }, []);
};

export const getRentalFields = ({ props }) => {
    const { itemsCartList } = props.cartObjects;
    let cfFields = getMetaConfig({
        viewMode: ConfigTypes.RENTALLIST,
        props: props, configName: ConfigTypes.WORK
    });
    let listData = reduceDataByFi({
        dataArr: cfFields, list: itemsCartList, fiName: ConfigTypes.IS_REDUCED,
        mode: ConfigTypes.RENTALLIST
    });

    let rentalFields = [...ConfigTypes.RENTAL_LIST];
    if (cfFields && cfFields.length) rentalFields = [...rentalFields, ...cfFields];
    rentalFields = rentalFields.map(item => {
        if (item[`${ConfigTypes.RENTALLIST}order`]) {
            item.order = item[`${ConfigTypes.RENTALLIST}order`];
        }
        return item;
    })
    rentalFields = SortHelper.sortByValue({
        data: rentalFields, sorted: "asc",
        field: `order`, isNumber: true
    });
    return { rentalFields, listData };
}


export const mergeWorkAndItemFields = ({ item, props, mode }) => {
    const addFields = getMetaConfig({
        viewMode: mode,
        props: props, configName: ConfigTypes.WORK
    });
    let buff = { metadata: { fields: {} } };
    if (item && item.metadata && item.metadata.fields) {
        buff.id = item.id;
        buff.metadata.fields = { ...item.metadata.fields };
    }
    let addItem = addWorkFieldsToItem({
        work: props.mediaObjects.currentWork,
        item: buff,
        addFields,
        viewMode: mode,
    });
    let newItems = toggleListItem({
        cartObjects: props.cartObjects,
        configName: ConfigTypes.ITEM, item: addItem
    });
    return newItems;
}

export const addNewItemToCart = ({ item, newItem, itemsCartList, showdates = null }) => {
    let newItemsCart = [...itemsCartList];
    let cartIdx = itemsCartList.findIndex(el => el.id == item.id);
    if (cartIdx > -1) {
        newItemsCart = itemsCartList.map(el => {
            if (el.id === item.id) {
                let cartAmount = 1;
                if (el.cartAmount) cartAmount = el.cartAmount + 1;
                if (showdates) return { ...el, cartAmount, showdates };
                return { ...el, cartAmount };
            }
            return el;
        });
    } else {
        newItemsCart.push({ ...newItem, cartAmount: 1, showdates });
    }
    return newItemsCart;
}

export const handleCalDoneClick = async ({ item, fm, props, dates }) => {
    const { itemsCartList, itemsDateObj } = props.cartObjects;
    let newDates = dates.map(date => {
        let newDate = date.setTime(date.getTime() + ConfigTypes.ADD_TWO_HOURS);
        newDate = new Date(newDate).toISOString().split('T')[0];
        return newDate;
    });
    let newItem = mergeWorkAndItemFields({
        item: item, props: props,
        mode: ConfigTypes.CARTLIST_WORKTOITEM
    });
    if (newItem && newItem.length) newItem = newItem[0];
    let newItemsCart = addNewItemToCart({ item, newItem, itemsCartList, showdates: newDates });
    console.log("LOGS: handleCalDoneClick item newDates", item, newDates);
    //props.addToFeCart({ clid: item.id, showdates: newDates });
    const res = await window.flow.sdkFeReAddToCart(item.id, newDates);
    console.log("LOGS: LAMTEST addToFeCart res", res);
    if (res && res.success) {
        props.updateCartObjects({
            itemsCartList: newItemsCart,
            itemsDateObj: { ...itemsDateObj, [item.id]: newDates }
        });
    }
    showFeCartMsg({ msg: res.msg, fm, props });
}

export const handleWishListClick = ({ item, props, fm }) => {
    const { worksWishList } = props.cartObjects;
    const { currentWork } = props.mediaObjects;
    let wList = [...worksWishList];
    let addWork, addItem;
    const newItems = mergeWorkAndItemFields({
        item: item, props: props,
        mode: ConfigTypes.WISHLIST_WORKTOITEM
    });
    let wExists;
    if (currentWork && currentWork.id) {
        wExists = wList.find(w => w.id == currentWork.id);
        if (!wExists) {
            addWork = {id: currentWork.id, metadata: { fields: { ...currentWork.metadata.fields } }}
            wList.push(addWork);
        }
    }
    props.updateCartObjects({
        itemsWishList: newItems, worksWishList: wList
    });

    addItem = newItems.find(it => it.id == item.id);
    props.addToWatchlist({work: addWork, item: addItem, fm});
};

export const showWishList = ({ item, props, fm }) => {
    const { itemsWishList } = props.cartObjects;
    let isInList = itemsWishList.find(el => el.id == item.id);
    return (
        <div className="item-wishlistbox">
            <FontAwesomeIcon className="item-heart-bg" icon={faHeart} />
            <div onClick={() => handleWishListClick({ item, props, fm })}
                className={isInList ? "item-heart-active" : "item-heart-front"}>
                <FontAwesomeIcon icon={faHeart} />
            </div>
        </div>)
};


export const showCalendar = ({ item, fm, props, isCartSymbol = false }) => {
    return (
        <div className="listitem-item listitem-action">
            {canShow({ item, props }) &&
                <UIMultiCalendar formatMessage={props.intl.formatMessage} onBtnChooseClick={() => { }}
                    btnOkId="calendar.done" btnChooseId="calendar.choose" isCartSymbol={isCartSymbol}
                    onDateAction={({ item, dates }) => handleCalDoneClick({ item, fm, props, dates })}
                    item={item} cartObjects={props.cartObjects}
                    onBtnOkClick={() => { }} onCalendarClick={() => { }} />
            }
        </div>
    )
}

export const showFeCartMsg = ({ msg, fm, props }) => {
    let htmlMsg = msg;
    switch (msg) {
        case ConfigTypes.NOT_LOGGED_IN:
            htmlMsg = fm({ id: 'cart.notLoggedIn' });
            break;
        case ConfigTypes.ADDED_TO_CART:
            htmlMsg = fm({ id: 'cart.addedToCart' });
            break;
        case ConfigTypes.COULD_NOT_REMOVE:
            htmlMsg = fm({ id: 'couldNotRemove.msg' });
            break;  
        default:
            htmlMsg = fm({ id: 'cart.somethingWrong' });
            break;
    }
    showConfirmMsgDlg({
        htmlMsg, formatMessage: fm, cb: () => {
            if (msg == ConfigTypes.NOT_LOGGED_IN) {
                console.log("LOGS: showFeCartMsg shouldLogOut =  true");
                if (props) props.updateAuthObjects({ shouldLogOut: true });
            }
        }
    });
}

export const getWatchlistsID = ({cartObjects, authObjects, watchlists}) => {
    let userId, found;
    const {user} = authObjects;
    if(!watchlists) watchlists = cartObjects.watchlists;
    if(user && user.metadata && user.metadata.fields && user.metadata.fields.id){
        userId = user.metadata.fields.id
    }
    if(watchlists && watchlists.length){
        found = watchlists.find(li => li.sdkusers_id == userId);
        if(found && found.id) return found.id;
    }
    return null;
}

export const getInObj = ({getState, entry, type}) => {
    let listid = getWatchlistsID({
        authObjects: getState().auth.authObjects, 
        cartObjects: getState().cart.cartObjects
    });
    if(listid && entry) {
        let fields;
        if(entry.metadata && entry.metadata.fields) fields = entry.metadata.fields;
        return {listid, sprid: entry.id, type, fields};
    }
    return null;
}

export const toWishList = ({getState,watchlists, type}) => {
    let wishlist = [];
    let listid = getWatchlistsID({
        authObjects: getState().auth.authObjects, 
        cartObjects: getState().cart.cartObjects,
        watchlists
    });
    let watchlist = watchlists.find(li => li.id == listid);
    if(watchlist && watchlist.listels){
        wishlist = watchlist.listels.filter(el => el.type == type);
        if(wishlist && wishlist.length){
            wishlist = wishlist.map(li => ({
                orig_id: li.id, watchlist_id: li.watchlist_id,
                id: li.element_id, metadata: {fields: li.fields}}));
        }
    }
    return wishlist;
}
